import React, { useState } from 'react';
import './settings-modal.scss';
import DropDownMenu from 'src/components/base/DropDownMenu/DropDownMenu';
import {
  setAudioDevice,
  setMicDevice,
} from 'src/redux/actions/teleTherapyActions';
import { useDispatch, useSelector } from 'react-redux';
import TestSpeaker from './TestSpeaker';
import MicActivity from './MicActivity';
import { Typography } from "src/latest/src/components";

interface AudioSettingsProps {
  deviceController: any;
  audioDevices: MediaDeviceInfo[];
  audioOutputDevices: MediaDeviceInfo[];
}

const AudioSettings: React.FC<AudioSettingsProps> = ({ deviceController, audioDevices, audioOutputDevices }) => {
  const dispatch = useDispatch();
  const { audioDevice, micDevice } = useSelector(
    ({ teleTherapy }: any) => teleTherapy,
  );
  const [micSelected, setMicSelected] = useState(micDevice?.deviceId);
  const [audioOutputSelected, setAudioOutputSelected] = useState(
    audioDevice?.deviceId,
  );

  const getDevicesAsOptions = (devices: MediaDeviceInfo[]) => {
    return devices?.map(device => ({
      value: device?.deviceId,
      title: device?.label,
    }));
  };

  const onMicSelectionChange = (deviceId: string) => {
    const selectedDevice = audioDevices.find(
      device => device.deviceId === deviceId,
    );

    if (selectedDevice) {
      setMicSelected(deviceId);
      dispatch(setMicDevice(selectedDevice));
    }
  };

  const onAudioOutputSelectionChange = (deviceId: string) => {
    const selectedDevice = audioOutputDevices.find(
      device => device.deviceId === deviceId,
    );

    if (selectedDevice) {
      setAudioOutputSelected(deviceId);
      dispatch(setAudioDevice(selectedDevice));
    }
  };

  return (
    <div className="video-settings audio-settings">
      <div className="upper-section">
        <div className="video-device-and-resolution">
          <div className="video-device">
            <Typography
              variant="size-16"
              color="color-2"
              weight="semi-bold"
              className="mb-3"
            >
              Microphone
            </Typography>
            <div className="video-device-dropdown pe-3">
              <DropDownMenu
                menu={getDevicesAsOptions(audioDevices)}
                toggler={
                  audioDevices.find(device => device.deviceId === micSelected)
                    ?.label || ''
                }
                onClick={onMicSelectionChange}
                className={'device-dropdown'}
              />
            </div>
            <MicActivity deviceController={deviceController} />
          </div>
          <div className="video-device">
            <Typography
              variant="size-16"
              color="color-2"
              weight="semi-bold"
              className="mb-3"
            >
              Speaker
            </Typography>
            <div className="video-resolution-dropdown ps-2">
              <DropDownMenu
                menu={getDevicesAsOptions(audioOutputDevices)}
                toggler={
                  audioOutputDevices.find(
                    device => device.deviceId === audioOutputSelected,
                  )?.label || ''
                }
                onClick={onAudioOutputSelectionChange}
                className={'device-dropdown'}
              />
            </div>
            <TestSpeaker
              deviceController={deviceController}
              audioOutputDevices={audioOutputDevices}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudioSettings;
